<app-header></app-header>
<div class="not-found-container">
  <h1>404</h1>
  <div class="not-found-msg">
    <h3>{{ 'not-found.title' | translate }}</h3>
    <p>{{ 'not-found.message' | translate }}</p>
  </div>
  <button mat-button (click)="backToHome()" class="btn-fill-primary btn-size-M">
    {{ 'not-found.back-to-home' | translate }}
  </button>
</div>
